import type { DomainRecord, DomainRecordType } from '@/entities/domain';
import request from '@/shared/api/request';

export const updateDomainRecord = (
  domain_name: string,
  record_id: number,
  payload: DomainRecordType,
): Promise<{ record: DomainRecord }> =>
  request({
    url: `/domains/${domain_name}/records/${record_id}`,
    method: 'PUT',
    data: payload,
  });
